// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(
    schema,
    "X_SPELLS_OF_SAME_REASON_IN_Y_PERIOD_TYPE",
  );

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      xSpellsOfSameReasonInYPeriodType: {
        required: findSchemaRequired(typeSchema, "xSpellsOfSameReasonInYPeriodType"),
        title: "X Spells Of Same Reason In Y Period Type",
        properties: {
          sameReasonOnly: {
            type: "boolean",
            title: "Same Reason Only",
          },
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
          spells: {
            type: "integer",
            title: "Spells",
          },
          absenceReasons: findSchemaPropertyByName(
            typeSchema,
            "xSpellsOfSameReasonInYPeriodType",
            "absenceReasons",
          ),
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "xSpellsOfSameReasonInYPeriodType"],
  };
};

export const uiSchema = (t: (s: string) => string) => ({
  ...baseUiSchema(t),
  xSpellsOfSameReasonInYPeriodType: {
    sameReasonOnly: {
      "ui:widget": "toggle",
    },
    absenceReasons: {
      "ui:widget": "hidden",
    },
  },
});

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
